export default __webpack_public_path__ + "static/media/challenge_not_found.33eec018.svg";